import React from 'react';

import { hasPermission as hasPermissionCreator } from 'utils/user/conditionals';

const withRolesGuard = (roles) => (Component) => (props) => {
  const hasPermission = hasPermissionCreator();
  return hasPermission(roles) ? <Component {...props} /> : null;
};
export default withRolesGuard;
